<script>
import graphEdge from './GraphEdge'
import graphNode from './GraphNode'
import graphAnchor from './GraphAnchor'
import graphBrother from './GraphBrother'
import graphNodeReplacement from './GraphNodeReplacement'
import subBoardCard from './SubBoardCard'
import {
  addHighlight, addChilds, addDummyChilds, addLayerNum, getMaxLayerNum, SortByLayer, SortByChilds, setNodesAtEqualIntervals, setNodesPositionFromChilds, setNodesPositionFromParent, deleteDummyChilds,
  getLayerNumber, getNumbesrforAnchor, addEdgePosition, getAnchorQuestionIdfromNumber,
  getBrotherNodes, getBrotherSegments, getBoardLayerNum, getBoardCardPosition, getBoardSize
} from './graphUtility'
import { updateParentId, updateNodeOrder, addNodebyCard } from '@/api/FirebaseTreesWrapper.js'
import { removeUrl, removeHtml, removeMention, reduceMsg, addUrlInNoMsg, sortArraybyCreatedAt } from '@/api/Utilities.js'
import Store from '@/store/index.js'
import * as constant from '@/constant/constant.js'
const DOMAIN_NAME = constant.DEFAULT_DOMAIN_NAME

export default {
  props: [
    'treeId',
    'questions',
    'updatingMsg',
    'edittingMsg',
    'focusingTextId',
    'selector',
    'loginUserId', // Treeを見ているユーザーのID
    'isTeamOwner', // Team Owner
    'scale',
    'translateX',
    'translateY',
    'questionSolved',
    'maxBranchNum',
    'isSolved',
    'nodesNum',
    'latestQuestion',
    'team',
    'queryNodeNum',
    'graphWidth',
    'members',
    'isMouseDown',
    'offsetX',
    'offsetY',
    'mouseTarget',
    'boardCardData',
    'enableBoard',
    'nodeDirection'
  ],
  components: {
    graphEdge,
    graphNode,
    graphAnchor,
    graphBrother,
    graphNodeReplacement,
    subBoardCard
  },
  data () {
    return {
      nodeWidth: 150,
      nodeHeight: 160,
      nodeMarginX: 25,
      nodeMarginY: 50,
      temporaryPosX: 0,
      temporaryPosY: 0,
      graphDisplayData: [],
      trail: [], // カーソルキー操作によるノード移動のルートを覚えておくための配列.
      currentLayerNumber: [], // 現在選択中のNodeのレイヤー番号.
      toGraphsMap: new Map(),
      fromGraphs: [],
      tempNode: {},
      focusedNodeNumber: -1,
      dragStartNode: null,
      brotherSegments: [], // 兄弟の並び替えの当たり判定ブロック
      startX: 0,
      startY: 0,
      dragX: 0,
      dragY: 0,
      isDragging: false,
      boardCards: [],
      boardMinX: 0,
      boardMinY: 0,
      boardHeight: 0,
      treeHeight: 0,
      editNodeId: '',
      cardLimit: constant.DEFAULT_CARD_LIMIT
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeyDown)
  },
  created () {
    // console.log('=======WELLCOME TO GRAPH VUE=======')
    window.addEventListener('keydown', this.onKeyDown)
    this.currentLayerNumber = 0
    this.trail.push(this.currentLayerNumber)
  },
  computed: {
    graph () {
      return { transform: 'scale(' + this.scale + ',' + this.scale + ') translate(' + this.translateX + 'px' + ',' + this.translateY + 'px' + ')' }
    },
    board () {
      return { transform: 'scale(' + this.scale + ',' + this.scale + ') translate(' + 0 + 'px' + ',' + this.translateY + 'px' + ')' }
    }
  },
  watch: {
    questions: function (val) {
      // Drag中はTreeからのNode追加による再描画を止める
      if (!this.isDragging) {
        this.renderTree()
      }
    },
    boardCardData: function (val) {
      if (!this.isDragging) {
        this.renderBoard()
      }
    },
    enableBoard: function (val) {
      if (!this.isDragging) {
        this.renderBoard()
      }
    },
    scale: function (val) {
      if (!this.isDragging) {
        this.renderBoard()
      }
    },
    updatingMsg: function (val) {
      // 暫定要素がなければreturn
      const targetIndex = this.questions.findIndex(({questionId}) => questionId === 'temporaryId')
      if (targetIndex === -1) { return }
      if (!this.updatingMsg) {
        this.updatingMsg = constant.DEFAULT_UPDATING_MSG
      }
      this.questions[targetIndex].question = this.updatingMsg
    },
    edittingMsg: function (val) {
      // 暫定要素がなければreturn
      const targetIndex = this.questions.findIndex(({questionId}) => questionId === this.editNodeId)
      if (targetIndex === -1) { return }
      this.questions[targetIndex].question = this.edittingMsg
    },
    isMouseDown: function (val) {
      if (this.isMouseDown) {
        if (location.hostname !== DOMAIN_NAME) { console.log('graph.vue -- mouse on') }
      } else {
        if (location.hostname !== DOMAIN_NAME) { console.log('graph vue -- mouse up : branch clear') }
        this.$emit('endMoveBranch', '')
        this.dragStartNode = null
        this.startX = 0
        this.startY = 0
        this.isDragging = false
        this.brotherSegments = []
      }
    },
    mouseTarget: function (val, old) {
      if (old === 'parent-collision parent-collision-color') { return }
      if (old === 'brother-color brother-highlight') { return }
      // 'node'要素をcatchするとdragStartNodeが入力され'node' divがpointer-disableになり、'content'に変化
      if (val !== old && (old !== 'card' && old !== 'cardThinking' && old !== 'cardImportant') && val === 'content') {
        console.log('node判定')
        this.startX = this.offsetX
        this.startY = this.offsetY
        this.isDragging = true
      }
      // 'card'要素をcatchするとdragStartNodeが入力され'card' divがpointer-disableになり、'content'に変化
      if (val !== old && (old === 'card' || old === 'cardThinking' || old === 'cardImportant') && val === 'content') {
        console.log('card判定')
        this.startX = this.offsetX
        this.startY = this.offsetY
        this.isDragging = true
      }
    },
    offsetX: function () {
      this.dragX = (this.offsetX - this.startX) / this.scale
    },
    offsetY: function () {
      this.dragY = (this.offsetY - this.startY) / this.scale
    }
  },
  methods: {
    clickCard (card) {
      this.$emit('clickCard', card)
    },
    clickNode (id, posx, posy, isFocusingNode, text, fromNum) {
      this.editNodeId = ''
      this.focusedNodeNumber = fromNum

      if (!isFocusingNode) {
        // キー操作によるノード移動の履歴を初期化 & 現在のレイヤのNodeの番号(兄弟内の番号)だけ覚えておく.
        this.trail = []
        this.currentLayerNumber = getLayerNumber(id, this.questions)
        for (let i = 0; i < this.currentLayerNumber; i++) {
          this.trail.push(-1)
        }
        const nodeIndex = this.questions.findIndex(({questionId}) => questionId === id)
        const parentNodeIndex = this.questions.findIndex(({questionId}) => questionId === this.questions[nodeIndex].parentId)
        if (parentNodeIndex === -1) {
          this.trail.push(0)
        } else {
          const tmp = id
          const numberInBrothers = this.questions[parentNodeIndex].childs.findIndex((id) => id === tmp)
          this.trail.push(numberInBrothers)
        }
      }
      // 暫定の要素削除
      const targetIndex = this.questions.findIndex(({questionId}) => questionId === 'temporaryId')
      if (targetIndex !== -1) { this.questions.splice(targetIndex, 1) }
      this.tempNode = {}

      const x = -posx + this.graphWidth / 2.0
      const y = this.number !== 0 ? -posy + window.innerHeight * 0.3 : -posy + 50
      this.$emit('clickNode', id, x, y, isFocusingNode)
    },
    clickTempNode (posx, posy) {
      this.editNodeId = ''
      const x = -posx + this.graphWidth / 2.0
      const y = -posy + window.innerHeight * 0.4
      this.temporaryPosX = posx
      this.temporaryPosY = posy
      this.selector.id = 'temporaryId'
      this.selector.group = 'nodes'
      this.renderTree()
      this.$emit('clickAddQuestion', this.tempNode.parentId, x, y)
    },
    clickEdge (id) {
      // 暫定の要素削除
      const targetIndex = this.questions.findIndex(({questionId}) => questionId === 'temporaryId')
      if (targetIndex !== -1) { this.questions.splice(targetIndex, 1) }
      this.tempNode = {}
      this.$emit('clickEdge', id)
    },
    clickAddQuestion (id, posx, posy) {
      this.editNodeId = ''
      // 暫定の要素削除
      const targetIndex = this.questions.findIndex(({questionId}) => questionId === 'temporaryId')
      if (targetIndex !== -1) { this.questions.splice(targetIndex, 1) }
      this.tempNode = {
        questionId: 'temporaryId',
        number: this.nodesNum,
        question: this.updatingMsg,
        parentId: id,
        color: 'temporary',
        userId: this.loginUserId,
        order: Date.now()
      }
      const x = -posx + this.graphWidth / 2.0
      const y = -posy + window.innerHeight * 0.4
      this.temporaryPosX = posx
      this.temporaryPosY = posy
      this.focusedNodeNumber = -1
      this.renderTree()
      this.$emit('clickAddQuestion', id, x, y)
    },
    clickDeleteQuestion (id) {
      this.$emit('clickDeleteQuestion', id)
    },
    clickEditQuestion (id) {
      this.editNodeId = id
      this.$emit('clickEditQuestion', id)
    },
    alertAnonymous (id) {
      this.$emit('alertAnonymous', id)
    },
    startMoveBranch (node, type) {
      // Node上でMouseDownしたらDrag開始.
      this.$emit('startMoveBranch')
      if (type === 'card') {
        this.dragStartNode = node
        this.dragStartNode.type = 'card'
      } else {
        this.dragStartNode = node
        this.dragStartNode.type = 'node'
        const brotherNodes = getBrotherNodes(node, this.graphDisplayData)
        if (brotherNodes.length > 0) {
          this.brotherSegments = getBrotherSegments(node, brotherNodes, this.nodeWidth, this.nodeMarginX)
        } else {
          this.brotherSegments = []
        }
        if (location.hostname !== DOMAIN_NAME) { console.log('brotherSegments') }
        if (location.hostname !== DOMAIN_NAME) { console.log(this.brotherSegments) }
        if (location.hostname !== DOMAIN_NAME) { console.log('startMoveBranch: ' + node.number + ' : ' + node.questionId) }
      }
    },
    async endMoveBranchForParent (node) {
      // Node上でMouseUpしたらDrag終了.
      this.$emit('endMoveBranch')
      // 対象Nodeが選択されていない場合はreturn
      if (!this.dragStartNode) {
        this.dragStartNode = null
        this.brotherSegments = []
        return
      }
      if (this.dragStartNode.type === 'card') {
        // nodeの追加
        await addNodebyCard(this.treeId, node.questionId, this.team, this.dragStartNode)
      } else {
        if (location.hostname !== DOMAIN_NAME) { console.log('endMoveBranchForParent: ' + node.questionId) }
        // 対象Nodeと移動先Nodeが同じならreturn
        if (node.questionId === this.dragStartNode.questionId) {
          this.dragStartNode = null
          this.brotherSegments = []
          return
        }
        // 親の付け替え
        await updateParentId(this.treeId, this.dragStartNode.questionId, this.dragStartNode.parentId, node.questionId)
      }
      this.dragStartNode = null
      this.brotherSegments = []
    },
    duringMoveBranchForParent (node, flag) {
      if (flag) {
        // 付け替え領域に侵入した
        this.isDragging = false
      } else {
        // 付け替え領域から脱した
        this.isDragging = true
      }
    },
    async endMoveBranchForBrother (indexNum) {
      // BrotherSegment上でMouseUpしたらDrag終了.
      if (location.hostname !== DOMAIN_NAME) { console.log('endMoveBranchForBrother: ' + indexNum) }
      this.$emit('endMoveBranch', '')
      // 対象Nodeが選択されていない場合はreturn
      if (!this.dragStartNode) {
        this.dragStartNode = null
        this.brotherSegments = []
        return
      }
      // 兄弟の並び替え
      const brotherIndex = this.brotherSegments.findIndex(({index}) => index === indexNum)
      await updateNodeOrder(this.treeId, this.dragStartNode.questionId, this.brotherSegments[brotherIndex].order)
      this.dragStartNode = null
      this.brotherSegments = []
    },
    duringMoveBranchForBrother (node, flag) {
      if (flag) {
        // 付け替え領域に侵入した
        this.isDragging = false
      } else {
        // 付け替え領域から脱した
        this.isDragging = true
      }
    },
    getParentCollison (node, nodes) {
      // drag nodeが存在しない or 一致したらreturn
      if (!this.dragStartNode || this.dragStartNode.questionId === node.questionId) { return false }
      // 自分の実親も変化の意味ないのでreturn
      if (this.dragStartNode.parentId === node.questionId) { return false }
      // 対象nodeの親をさかのぼっていきdragStartNodeが含まれるか判断
      let parentId = node.parentId
      let parentIndex = 0
      let isValidArea = true
      while (parentId) {
        parentIndex = nodes.findIndex(({questionId}) => questionId === parentId)
        if (parentId === this.dragStartNode.questionId) {
          isValidArea = false
          parentId = null
        } else {
          parentId = nodes[parentIndex].parentId
        }
      }
      return isValidArea
    },
    getDragStartNodeId (node) {
      if (!node) { return null }
      return node.questionId
    },
    getColor (color) {
      if (color === 'root' || color === 'important' || color === 'thinking' || color === 'soso') {
        return color
      } else {
        return 'soso'
      }
    },
    getGraphText (msg) {
      let text = ''
      text = removeHtml(msg)
      text = removeUrl(text)
      text = removeMention(text, this.dragStartNode.mentionedIds, this.members)
      text = reduceMsg(text, this.cardLimit)
      text = addUrlInNoMsg(text)
      return text
    },
    onKeyDown (e) {
      let key = ''
      switch (e.which) {
        case 13:
          key = 'enter'
          break
        case 27:
          key = 'escape'
          break
        case 37:
          key = 'left'
          break
        case 38:
          key = 'up'
          break
        case 39:
          key = 'right'
          break
        case 40:
          key = 'down'
          break
        case 113:
          key = 'f2'
          break
        default:
          return
      }
      if (document.activeElement.tagName !== 'TEXTAREA') { // textareaにフォーカスが当たっていない時はキー操作でNode移動できる.
        if (this.isSolved && key === 'enter') { return } // Treeがcloseされている場合Enterが効かないようにする.(新たなNodeをつけられない)
        e.preventDefault()
        this.TransferFocusingNode(key)
      } else {
        // textareaにフォーカスが当たっている時は, escapeキーとupキー以外は通常の動きをさせる.(Node移動させない)
        if (key === 'escape') {
          document.activeElement.blur()
          e.preventDefault()
          this.TransferFocusingNode(key)
        } else if (key === 'up') {
          if (this.tempNode.parentId && this.updatingMsg === constant.DEFAULT_UPDATING_MSG) {
            document.activeElement.blur()
            e.preventDefault()
            this.TransferFocusingNode('escape') // TempNodeにフォーカスしていて文字未入力ならばupキーはescapeキーと同じ動きをする.
          }
        }
      }
    },
    TransferFocusingNode (key) {
      let selector = {id: '', group: ''}
      switch (key) {
        case 'down':
        {
          if (this.tempNode.parentId) { return } // tempNode.parentIdが存在する = dummyNodeにフォーカス中. dummyNodeから下には行かない.

          // 移動先の子Nodeの番号(兄弟内番号)を決定.
          let targetChildNumber = -1
          // console.log(this.currentLayerNumber)
          // console.log(this.trail)
          if (this.trail.length > this.currentLayerNumber + 1) { // 移動先が到達済みのレイヤか否か.
            targetChildNumber = this.trail[this.currentLayerNumber + 1]
          } else {
            targetChildNumber = 0 // 未到達のレイヤだったら0番(兄弟内の番号)のNodeに飛ぶ.
          }
          const childIndex = this.questions.findIndex(({number}) => number === this.focusedNodeNumber)
          const targetChildNodeId = this.questions[childIndex].childs[targetChildNumber]
          if (targetChildNodeId.includes('_dummy')) { return } // 子供がついていないnodeには, "_dummy"というidを持つNodeが仮の子供がいる. この仮の子供には移動しない.
          const targetIndex = this.questions.findIndex(({questionId}) => questionId === targetChildNodeId)
          this.focusedNodeNumber = this.questions[targetIndex].number

          // キー操作によるノード移動の履歴を更新.
          if (this.trail.length === this.currentLayerNumber + 1) {
            this.trail.push(0)
          }
          this.currentLayerNumber += 1

          selector.id = targetChildNodeId
          selector.group = 'nodes'
          // console.log(this.currentLayerNumber)
          // console.log(this.trail)
          break
        }
        case 'up':
          let parentId = ''
          if (this.tempNode.parentId) { // tempNode.questionIdが存在する = dummyNodeにフォーカス中.
            parentId = this.tempNode.parentId
          } else {
            const parentIndex = this.questions.findIndex(({number}) => number === this.focusedNodeNumber)
            parentId = this.questions[parentIndex].parentId
          }
          if (parentId === '') { return }
          const targetIndex = this.questions.findIndex(({questionId}) => questionId === parentId)
          this.focusedNodeNumber = this.questions[targetIndex].number

          // キー操作によるノード移動の履歴を更新.
          this.currentLayerNumber -= 1
          const parentNodeIndex = this.questions.findIndex(({questionId}) => questionId === parentId)
          if (parentNodeIndex === 0) {
            this.trail[this.currentLayerNumber] = 0
          } else {
            const grandParentNodeIndex = this.questions.findIndex(({questionId}) => questionId === this.questions[parentNodeIndex].parentId)
            const parentNodeIndexInBrother = this.questions[grandParentNodeIndex].childs.findIndex((id) => id === parentId)
            this.trail[this.currentLayerNumber] = parentNodeIndexInBrother
          }

          selector.id = parentId
          selector.group = 'nodes'
          break
        case 'right':
        {
          let parentId = ''
          if (this.tempNode.parentId) { // tempNode.questionIdが存在する = dummyNodeにフォーカス中.
            parentId = this.tempNode.parentId
          } else {
            const parentIndex = this.questions.findIndex(({number}) => number === this.focusedNodeNumber)
            parentId = this.questions[parentIndex].parentId
          }
          if (parentId === '') { return }
          const parentNodeIndex = this.questions.findIndex(({questionId}) => questionId === parentId)
          const focusedNodeIndex = this.questions[parentNodeIndex].childs.findIndex((id) => id === this.selector.id)
          const targetBrotherNodeId = this.questions[parentNodeIndex].childs[focusedNodeIndex + 1]
          if (targetBrotherNodeId === undefined) { return }
          const targetIndex = this.questions.findIndex(({questionId}) => questionId === targetBrotherNodeId)
          this.focusedNodeNumber = this.questions[targetIndex].number

          // キー操作によるノード移動の履歴を更新.
          this.trail[this.currentLayerNumber] += 1
          for (let i = this.trail.length - 1; i > this.currentLayerNumber; i--) {
            this.trail.pop() // キー操作によるノード移動の履歴のうち現在のレイヤより下のものを忘れる.
          }

          selector.id = targetBrotherNodeId
          selector.group = 'nodes'
          break
        }
        case 'left':
        {
          let parentId = ''
          if (this.tempNode.parentId) { // tempNode.questionIdが存在する = dummyNodeにフォーカス中.
            parentId = this.tempNode.parentId
          } else {
            const parentIndex = this.questions.findIndex(({number}) => number === this.focusedNodeNumber)
            parentId = this.questions[parentIndex].parentId
          }
          if (parentId === '') { return }
          const parentNodeIndex = this.questions.findIndex(({questionId}) => questionId === parentId)
          const focusedNodeIndex = this.questions[parentNodeIndex].childs.findIndex((id) => id === this.selector.id)
          const targetBrotherNodeId = this.questions[parentNodeIndex].childs[focusedNodeIndex - 1]
          if (targetBrotherNodeId === undefined) { return }
          const targetIndex = this.questions.findIndex(({questionId}) => questionId === targetBrotherNodeId)
          this.focusedNodeNumber = this.questions[targetIndex].number

          // キー操作によるノード移動の履歴を更新.
          this.trail[this.currentLayerNumber] -= 1
          for (let i = this.trail.length - 1; i > this.currentLayerNumber; i--) {
            this.trail.pop() // キー操作によるノード移動の履歴のうち現在のレイヤより下のものを忘れる.
          }

          selector.id = targetBrotherNodeId
          selector.group = 'nodes'
          break
        }
        case 'enter':
          if (this.focusedNodeNumber === -1) { return }
          if (Store.state.user.isAnonymous) {
            this.alertAnonymous()
          } else {
            const targetIndex = this.graphDisplayData.findIndex(({number}) => number === this.focusedNodeNumber)
            const nodeData = this.graphDisplayData[targetIndex]
            const x = nodeData.posx - (this.nodeWidth - this.nodeMarginX) / 2
            const y = nodeData.posy
            this.clickAddQuestion(nodeData.questionId, x, y)
          }
          break
        case 'escape':
          if (this.tempNode.parentId) { // tempNode.questionIdが存在する = dummyNodeにフォーカス中.
            let parentId = this.tempNode.parentId
            const targetIndex = this.graphDisplayData.findIndex(({questionId}) => questionId === parentId)
            this.focusedNodeNumber = this.graphDisplayData[targetIndex].number
            selector.id = parentId
            selector.group = 'nodes'
          }
          break
        case 'f2':
        {
          if (this.tempNode.parentId) { return }
          if (this.focusedNodeNumber === -1) { return }
          const targetIndex = this.graphDisplayData.findIndex(({number}) => number === this.focusedNodeNumber)
          // 本人のnodeでなければreturn
          if (this.graphDisplayData[targetIndex].userId !== this.loginUserId) { return }
          const targetId = this.graphDisplayData[targetIndex].questionId
          this.clickEditQuestion(targetId)
          break
        }
      }
      // f2はnode移動しないのでFocuseは変わらない
      if (key === 'f2') { return }
      // up, down, left, right...はnode移動するのでFocuse変わる
      this.$emit('transferFocusingNode', selector, this.focusedNodeNumber)
    },
    renderTree () {
      // console.log('=========renderTree===========')
      // initialize
      let maxLayerNum = 0
      let questionsForTree = this.questions

      // 他者がquestionを更新してrenderTree()が走ってもtemporary Nodeをkeep
      if (this.tempNode.questionId) {
        if (this.latestQuestion.userId === this.loginUserId && this.latestQuestion.number >= this.tempNode.number && this.nodeDirection === 'depth') {
          // 自分がquestionを追加してrenderTree()が更新されるケース
          // 深さを選択している場合はtemporary Nodeの親nodeの付け替え
          this.tempNode.number = this.nodesNum
          this.tempNode.parentId = this.latestQuestion.id
          // 座標の再計算
          this.temporaryPosY += this.nodeHeight
          const x = -this.temporaryPosX + this.graphWidth / 2.0
          const y = -this.temporaryPosY + window.innerHeight * 0.4
          // postCard側も更新
          this.$emit('clickAddQuestion', this.latestQuestion.id, x, y)
        } else if (this.latestQuestion.userId === this.loginUserId && this.latestQuestion.number >= this.tempNode.number && this.nodeDirection === 'width') {
          // 自分がquestionを追加してrenderTree()が更新されるケース
          // 幅を選択している場合はtemporary Nodeのorderを更新
          this.tempNode.number = this.nodesNum
          this.tempNode.order = Date.now()
          // 座標の再計算
          this.temporaryPosX += this.nodeWidth
          const x = -this.temporaryPosX + this.graphWidth / 2.0
          const y = -this.temporaryPosY + window.innerHeight * 0.4
          // postCard側も更新
          this.$emit('clickAddQuestion', this.tempNode.parentId, x, y)
        }
        // すでにtemporary Idがあるか確認
        const targetIndex = questionsForTree.findIndex(({questionId}) => questionId === 'temporaryId')
        // temporaryIdがあれば二重追加になるので何もしない
        if (targetIndex !== -1) { return }

        questionsForTree.push(this.tempNode)
        this.selector.id = 'temporaryId'
        this.selector.group = 'nodes'
      }
      // 配列Objectに要素childs[],layerNum, posxを追加
      for (const question of questionsForTree) {
        question.childs = []
        question.layerNum = 0
        question.posx = 0
        question.posy = 0
        question.highlight = false
        // console.log(question.number)
        // console.log(question.questionId)
      }
      // Edge highlight enabler
      if (this.selector && this.selector.id !== 'temporaryId') {
        questionsForTree = addHighlight(questionsForTree, this.selector)
      }
      // Childの計算
      questionsForTree = addChilds(questionsForTree)
      // 初期化目的でdummyChildsがいれば削除
      questionsForTree = deleteDummyChilds(questionsForTree)
      // graphをきれいに見せるために子なしNodesに偽装childを入れる
      questionsForTree = addDummyChilds(questionsForTree)
      // ノードの縦位置を計算する.(自分の存在するlayerが何番目か求める)
      questionsForTree = addLayerNum(questionsForTree)
      maxLayerNum = getMaxLayerNum(questionsForTree)
      this.treeHeight = maxLayerNum * this.nodeHeight
      // treeとboardの高さを比較して大きい方を返却する
      const graphHeight = Math.max(this.treeHeight, this.boardHeight)
      this.$emit('graphHeight', -graphHeight)
      // ノードをlayerNumの小さい順にソート
      questionsForTree = SortByLayer(questionsForTree, maxLayerNum)
      // layer順＆childs順にソート
      questionsForTree = SortByChilds(questionsForTree)
      // LayerNum毎の配列を作る
      let layerArrays = []
      for (let i = 0; i <= maxLayerNum; i++) {
        layerArrays[i] = questionsForTree.filter(function (questions) {
          return questions.layerNum === i
        })
      }
      // 各layerをnode数で等間隔配置
      questionsForTree = setNodesAtEqualIntervals(questionsForTree, layerArrays, maxLayerNum, this.nodeWidth)
      // 子→親の位置の整合性計算
      questionsForTree = setNodesPositionFromChilds(questionsForTree, layerArrays, maxLayerNum)
      // 親→子の位置の整合性計算
      questionsForTree = setNodesPositionFromParent(questionsForTree, layerArrays, maxLayerNum)
      // graphの見栄え目的でDummyで代入したchildsを削除
      questionsForTree = deleteDummyChilds(questionsForTree)

      // 位置座標の校正
      const calibrationRootPos = questionsForTree[0].posx
      // 最大値・最小値の算出
      const maxPosX = Math.max(...questionsForTree.map((question) => question.posx))
      const minPosX = Math.min(...questionsForTree.map((question) => question.posx))
      for (const question of questionsForTree) {
        // rootNodeを画面の中心持ってくる補正
        question.posx += this.graphWidth / 2.0 - calibrationRootPos
        question.posy = question.layerNum * this.nodeHeight + 50
      }
      // treeのgraph座標とgraph.vue座標は左右反転してるので、軸反転させる
      const maxWidth = -(minPosX - this.nodeWidth - calibrationRootPos)
      const minWidth = -(maxPosX + this.nodeWidth - calibrationRootPos)
      this.$emit('graphWidth', minWidth, maxWidth)
      this.graphDisplayData = addEdgePosition(questionsForTree, this.nodeHeight, this.nodeMarginY)
      // anchorの要素を計算
      this.toGraphsMap.clear()
      this.fromGraphs = []
      for (const data of this.graphDisplayData) {
        // AnchorNumberを計算する
        const anchorNumbers = getNumbesrforAnchor(data.question, data.number, this.questions)
        if (anchorNumbers) {
          const [fromGraph, toGraphs] = getAnchorQuestionIdfromNumber(data.number, anchorNumbers, this.graphDisplayData)
          this.fromGraphs.push(fromGraph)
          this.toGraphsMap.set(fromGraph.questionId, toGraphs)
        }
      }
    },
    renderBoard () {
      // initialize
      let tempCards = []
      // boardCardが0ならreturn
      if (this.boardCardData.length === 0) { return }
      // 配列Objectに要素childs[],layerNum, posxを追加
      for (const card of this.boardCardData) {
        let data = card
        data.layerNum = 0
        data.posx = 0
        data.posy = 0
        tempCards.push(data)
      }
      // cardをcreatAt順でソートする
      tempCards = sortArraybyCreatedAt(tempCards)
      // cardの縦位置を計算する.(自分の存在するlayerが何番目か求める)
      tempCards = getBoardLayerNum(tempCards)
      // 位置座標を計算する
      this.boardCards = getBoardCardPosition(tempCards, this.graphWidth, this.nodeWidth, this.nodeMarginX, this.nodeHeight, this.nodeMarginY, this.scale, this.graphDisplayData)
      ;[this.boardMinX, this.boardMinY, this.boardHeight] = getBoardSize(this.boardCards)

      // treeとboardの高さを比較して大きい方を返却する
      const graphHeight = Math.max(this.treeHeight, this.boardHeight)
      this.$emit('graphHeight', -graphHeight)
    }
  }
}
</script>
<style scoped>
body {
  font: 14px helvetica neue, helvetica, arial, sans-serif;
}
.nodeDrag {
  font-size:0.65rem;
  font-weight: bold;
  padding: 15px 8px 8px;
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 .25rem .25rem hsla(0, 0%, 0%, .3);
  background-image:
  linear-gradient(180deg, hsla(60, 100%, 85%, 1) 0.5rem, hsla(60, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(60, 100%, 85%, 0.2), hsla(60, 100%, 85%, 0.2));
  opacity: 0.7;
  z-index: 1;
  pointer-events: none;
}
.soso {
  background-image:
  linear-gradient(180deg, hsla(60, 100%, 85%, 1) 0.5rem, hsla(60, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(60, 100%, 85%, 0.2), hsla(60, 100%, 85%, 0.2));
}
.root{
  background-image:
  linear-gradient(180deg, hsla(200, 100%, 85%, 1) 0.5rem, hsla(200, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(200, 100%, 85%, 0.2), hsla(200, 100%, 85%, 0.2));
}
.thinking {
  background-image:
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.6) 0.5rem, hsla(15, 100%, 85%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(15, 100%, 85%, 0.2), hsla(15, 100%, 85%, 0.2));
}
.important {
  background-image:
  linear-gradient(180deg, hsla(100, 100%, 85%, 1) 0.5rem, hsla(100, 100%, 85%, 0.5) 0.75rem),
  linear-gradient(180deg, hsla(100, 100%, 85%, 0.2), hsla(100, 100%, 85%, 0.2));
}
.temporary {
  background-image:
  linear-gradient(180deg, hsla(290, 60%, 85%, 0.6) 0.5rem, hsla(290, 60%, 85%, 0.3) 0.75rem),
  linear-gradient(180deg, hsla(290, 60%, 85%, 0.2), hsla(290, 60%, 85%, 0.2));
}
.pointer-disable {
  pointer-events: none;
  height: 0px;
}
.pointer-enable {
  pointer-events: auto;
  height: 0px;
}
.board-back {
  background-color: #fafafa;
  position: absolute;
  border: 2.0px solid rgba(200, 200, 200, 0.5);
  height: 0px;
  width: 0px;
}

</style>
<template>
  <div>
    <div :style="graph" id="graph" :class="{ 'pointer-disable' : dragStartNode }">
      <graphNode
      v-for="data in graphDisplayData"
      :key="data.id"
      :treeId="treeId"
      :nodeData="data"
      :loginUserId="loginUserId"
      :isTeamOwner="isTeamOwner"
      :x="data.posx"
      :y="data.posy"
      :w="nodeWidth"
      :h="nodeHeight"
      :marginX="nodeMarginX"
      :marginY="nodeMarginY"
      :maxBranchNum="maxBranchNum"
      :selector="selector"
      :isSolved="isSolved"
      :team="team"
      :queryNodeNum="queryNodeNum"
      :focusingTextId="focusingTextId"
      :members="members"
      :graphLength="graphDisplayData.length"
      :isMouseDown="isMouseDown"
      :focusedNodeNumber="focusedNodeNumber"
      @catchNode="startMoveBranch"
      @clickNode="clickNode"
      @clickTempNode="clickTempNode"
      @clickAddQuestion="clickAddQuestion"
      @alertAnonymous="alertAnonymous"
      @clickDeleteQuestion="clickDeleteQuestion"
      @clickEditQuestion="clickEditQuestion"
      />
      <graphEdge
      v-for="data in graphDisplayData"
      :key="data.id"
      :id="data.questionId"
      :x1="data.x1 - nodeMarginX/2"
      :y1="data.y1"
      :x2="data.x2 - nodeMarginX/2"
      :y2="data.y2"
      :highlight = "data.highlight"
      :selector = "selector"
      @clickEdge="clickEdge"
      />
      <div v-for="fromGraph in fromGraphs" :key="fromGraph.id" >
        <graphAnchor
        v-for="toGraph in toGraphsMap.get(fromGraph.questionId)"
        :key="toGraph.id"
        :x1="fromGraph.x2 - nodeMarginX/2"
        :y1="fromGraph.y2"
        :x2="toGraph.x2 - nodeMarginX/2"
        :y2="toGraph.y2"
        :nodeMarginY="nodeMarginY"
        :nodeHeight="nodeHeight"
        />
      </div>
      <!-- 兄弟nodeの当たり判定 -->
      <graphBrother v-for="data in brotherSegments" :class="{ 'pointer-enable' : dragStartNode }"
      :key="data.id"
      :index="data.index"
      :valid="data.valid"
      :x1="data.x1"
      :x2="data.x2"
      :y="data.y"
      :w="nodeWidth"
      :h="nodeHeight"
      :marginX="nodeMarginX"
      :marginY="nodeMarginY"
      @releaseNode="endMoveBranchForBrother"
      @overSwappingNode="duringMoveBranchForBrother"
      />
      <!-- 親付け替えの当たり判定 -->
      <graphNodeReplacement  :class="{ 'pointer-enable' : dragStartNode }"
      v-for="data in graphDisplayData"
      :key="data.id"
      :nodeData="data"
      :x="data.posx"
      :y="data.posy"
      :w="nodeWidth"
      :h="nodeHeight"
      :marginX="nodeMarginX"
      :marginY="nodeMarginY"
      :isParentCollision="getParentCollison(data, graphDisplayData)"
      @releaseNode="endMoveBranchForParent"
      @overReplaceNode="duringMoveBranchForParent"
      />
      <!-- Drag Node -->
      <div v-if="dragStartNode && dragStartNode.type === 'node' && isDragging && dragStartNode.color !== 'temporary'" class="nodeDrag" :class="getColor(dragStartNode.color)" :style="{left:dragStartNode.posx - ((nodeWidth - nodeMarginX) / 2) + dragX + 'px', top:dragStartNode.posy + dragY + 'px', width:nodeWidth - nodeMarginX + 'px', height:nodeHeight - nodeMarginY + 'px'}">
        <span>{{getGraphText(dragStartNode.question)}}</span>
      </div>
      <!-- Drag Card -->
      <div v-if="dragStartNode && dragStartNode.type === 'card' && isDragging" class="nodeDrag" :class="getColor(dragStartNode.marker)" :style="{left:dragStartNode.posx - nodeWidth + dragX - translateX + 'px', top:dragStartNode.posy + dragY + 60 + 'px', width:nodeWidth - nodeMarginX + 'px', height:nodeHeight - nodeMarginY + 'px'}">
        <span>{{getGraphText(dragStartNode.question)}}</span>
      </div>
    </div>
    <div :style="board" id="board" :class="{ 'pointer-disable' : dragStartNode }" v-if="enableBoard">
      <div class="board-back" :style="{
        left:boardMinX - (3 * nodeWidth / 4) - 20 + 'px',
        top:boardMinY + 50 + 'px',
        width:nodeWidth - nodeMarginX + 18 + 'px',
        height:boardHeight + nodeHeight/2 + 70 + 'px'}">
      </div>
      <subBoardCard
      v-for="data in boardCards"
      :key="data.id"
      :card="data"
      :x="data.posx - 12"
      :y="data.posy + 60"
      :w="nodeWidth"
      :h="nodeHeight"
      :marginX="nodeMarginX"
      :marginY="nodeMarginY"
      :isMouseDown="isMouseDown"
      @catchNode="startMoveBranch"
      @clickCard="clickCard"
      />
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/tree/graph/Graph.vue